import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { resolveStorefrontOrgSlug } from "@/lib/api";
import { useAuthStore } from "@/store/auth";

function extractOrgSlugFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/s\/([^/]+)/i);
  return match?.[1] ? decodeURIComponent(match[1]).trim().toLowerCase() : null;
}

function buildStorefrontBasePath(orgSlug: string | null | undefined) {
  return orgSlug ? `/s/${orgSlug}` : "/";
}

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const accessToken = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);
  const hydrated = useAuthStore((s) => s.hydrated);

  const loc = useLocation();
  const orgSlug =
    extractOrgSlugFromPath(loc.pathname) || resolveStorefrontOrgSlug();
  const basePath = buildStorefrontBasePath(orgSlug);

  if (!hydrated) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="rounded-2xl border border-zinc-800 bg-[var(--card)] px-5 py-4 text-sm opacity-80">
          Autenticando…
        </div>
      </div>
    );
  }

  if (!accessToken || !user) {
    return (
      <Navigate
        to={`${basePath}/login?next=${encodeURIComponent(
          loc.pathname + loc.search,
        )}`}
        replace
      />
    );
  }

  return <>{children}</>;
}
